<script>
  import options from './OverlayLeadGate.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>

    <div class="be-overlay__title">
      {{ getLabel('modalTitle') }}
        <button @click="closeTheModal" autofocus class="be-overlay__close-button" aria-label="close">
          <svg role="presentation" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4322_10989)"><path d="M33 11L11 33" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 11L33 33" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4322_10989"><rect width="44" height="44" fill="white"/></clipPath></defs></svg>
        </button>
    </div>

    <div class="be-overlay-lead-gate be-overlay__content">

      <p>{{ getLabel('modalDescription') }}</p>

      <form class="be-overlay-lead-gate__form" v-on:submit.prevent="submitForm">
        <FormInputGeneric 
          inputName="name"
          v-model="name"
          :modelValue="name"
          :label="getLabel('nameLabel')"
          :isRequired="true"
          :isValidationError="displayErrors && !nameValidator(name)"
          :isValid="displayErrors && nameValidator(name)"
          :errorMessageLabel="getLabel('nameErrorLabel')"
        />
        <div class="be-overlay-lead-gate__form-row">
          <FormInputGeneric
            inputName="title"
            v-model="title"
            :modelValue="title"
            :label="getLabel('titleLabel')"
          />
          <FormInputGeneric
            inputName="company"
            v-model="company"
            :modelValue="company"
            :label="getLabel('companyLabel')"
          />
        </div>

        <FormInputGeneric
          inputName="email"
          v-model="email"
          :modelValue="email"
          :label="getLabel('emailLabel')"
          :isRequired="true"  
          :isValidationError="displayErrors && !emailValidator(email)"
          :isValid="displayErrors && emailValidator(email)"
          :errorMessageLabel="getLabel('emailErrorLabel')"  
        />

        <FormInputCheckbox 
          inputName="consent"
          :modelValue="consent.toString()"
          :label="getLabel('consentLabel')"
          :onChangeCallback="(e) => (consent = e.target.checked)"
          :isRequired="true"  
          :isValidationError="displayErrors && !consent"
          :isValid="displayErrors"
          :errorMessageLabel="getLabel('consentErrorLabel')"  
        />

        <div class="be-overlay-prompt__content-buttons be-color-theme--white-green">
          <button class="be-btn">{{ getLabel('accessFileButtonText') }}</button>
        </div>
      </form>
    </div>

</template>